import Manage from "..";
import { Button, Form, Input, Tooltip } from "antd";
import filterReg from "../../../utils/filterReg";
import { useEffect, useRef, useState } from "react";
import { Vehicle } from "../../../models/Vehicle";
import filterAll from "../../../utils/filterAll";
import { BsPrinter } from "react-icons/bs";
import ReactToPrint from "react-to-print";
import QRToyota from "../../../components/shared/QRToyota";
import { Pagination } from "antd";
import { RiFilterOffLine } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { AiOutlineCheck } from "react-icons/ai";
import fetchAllVehicles from "../../../services/fetchAllVehicles";

export default function AllQRCodes() {
  const [filtered, setFiltered] = useState<any>([]);
  const [vehicles, setVehicles] = useState<any>([]);

  const [filter, setFilter] = useState({ type: "", keyword: "" });
  const [search, setSearch] = useState("");
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [selected, setSelected] = useState<any>([]);

  const [form] = Form.useForm();

  const handleFetchVehicles = async () => {
    const response = await fetchAllVehicles();
    setVehicles(response?.payload);
  };

  const handleFilterCodes = ({ type, keyword }: any) => {
    setFilter({ type, keyword });
    const data = filterCodes(filter);
    setFiltered(data);
  };

  const clearAllFilters = () => {
    setSearch("");
    setSelected([]);
    form.resetFields();
    handleFilterCodes({ type: "", keyword: "" });
  };

  const filterCodes = (filter: any) => {
    let filtered: Vehicle[] = [];
    switch (filter.type) {
      case "registration":
        filtered = filterReg(vehicles, filter);
        break;
      default:
        filtered = filterAll(vehicles);
        break;
    }
    return filtered;
  };

  const qrpages = useRef(null);

  const handleFiltered = () => {
    const data = filterCodes(filter);
    setFiltered(data);
  };

  useEffect(() => {
    handleFiltered();
  }, [filtered]);

  const onChange = (current: any) => {
    setCurrent(current);
  };

  const onShowSizeChange = (current: any, pageSize: any) => {
    setCurrent(current);
    setPageSize(pageSize);
  };

  const getPaginatedData = (data: any) => {
    const startIndex = current * pageSize - pageSize;
    const endIndex = startIndex + pageSize;
    return data.slice(startIndex, endIndex);
  };

  const handleAddItem = (item: any) => {
    setSelected([...selected, item]);
  };

  const handleRemoveItem = (item: any) => {
    var filtered = selected.filter(function (value: any, index: any, arr: any) {
      return value._id !== item?._id;
    });
    setSelected(filtered);
  };

  const filtere = vehicles?.filter((vehicle: any) =>
    vehicle?.registration?.includes(`${search}`)
  );

  useEffect(() => {
    handleFetchVehicles();
  }, []);

  return (
    <Manage
      title={"QR Codes"}
      subtitle={"All"}
      description={"List of all codes"}
      actions={
        <ReactToPrint
          trigger={() => {
            return (
              <button className="border rounded-md px-2 py-1 flex items-center hover:bg-red-100">
                <BsPrinter />
                <span className="ml-2">Print</span>
              </button>
            );
          }}
          content={() => qrpages.current}
        />
      }
    >
      <>
        <div className="bg-gray-100 h-10 border-b mb-4 flex items-center p-4">
          <Form layout="inline" form={form}>
            <Form.Item name="registration">
              <Input
                placeholder="Search by registration"
                suffix={
                  <Tooltip title="Search vehicle by registration">
                    <FiSearch style={{ color: "rgba(0,0,0,.45)" }} />
                  </Tooltip>
                }
                onChange={(val: any) => {
                  setSearch(val.target.value);
                }}
              />
            </Form.Item>
            <Button
              className="ml-2 focus:outline-none hover:bg-red-100"
              onClick={clearAllFilters}
            >
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>
        </div>
        <div className="flex justify-center items-center mt-4">
          <Pagination
            current={current}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onChange}
            total={vehicles?.length || 0}
            defaultPageSize={pageSize}
          />
        </div>

        <div className="px-4 mt-2">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-3 mt-5 sm:mt-0 md:mt-0 sm:col-span-12 md:col-span-3 mx-1">
              <div className="grid grid-cols-12 gap-2 flex-1" ref={qrpages}>
                {getPaginatedData(filtere)?.map(
                  (vehicle: any, index: number) => (
                    <div
                      className="col-span-12 hidden sm:block  mt-5 sm:mt-0 md:mt-0 sm:col-span-6 md:col-span-6 mx-1"
                      key={index}
                    >
                      <div className="flex flex-row justify-center items-center my-1 px-2 border border-gray-300 rounded-sm">
                        {selected.includes(vehicle) ? (
                          <button
                            className="flex justify-center items-center h-6 w-8 border hover:bg-green-200 bg-green-200"
                            onClick={() => handleRemoveItem(vehicle)}
                          >
                            <AiOutlineCheck />
                          </button>
                        ) : (
                          <button
                            className="flex justify-center items-center h-6 w-8 border hover:bg-green-200"
                            onClick={() => handleAddItem(vehicle)}
                          ></button>
                        )}
                        <div className="text-gray-600 py-1 text-lg w-full truncate text-center">
                          {vehicle?.registration}
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>

            <div className="col-span-9 mt-5 sm:mt-0 md:mt-0 sm:col-span-12 md:col-span-9 mx-1">
              <div
                className="grid grid-cols-12 gap-2 flex-1 mx-2"
                ref={qrpages}
              >
                {selected?.length !== 0 ? (
                  <>
                    {selected?.map((vehicle: any, index: number) => (
                      <div
                        className="col-span-3 mt-5 sm:mt-0 md:mt-0 sm:col-span-3 md:col-span-2 mx-1"
                        key={index}
                      >
                        <div className="my-1  border-gray-300 rounded-lg">
                          <div className="flex flex-col justify-center items-center">
                            <div className="text-gray-600 pt-2 text-lg truncate text-center">
                              {vehicle?.registration}
                            </div>
                            <div className="w-auto pb-2">
                              <QRToyota
                                value={`${vehicle?.registration}`}
                                title={"Toyota"}
                                size={120}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {getPaginatedData(filtere)?.map(
                      (vehicle: any, index: number) => (
                        <div
                          className="col-span-12 mt-5 sm:mt-0 md:mt-0 sm:col-span-3 md:col-span-2 mx-1"
                          key={index}
                        >
                          <div className="my-1  border-gray-300 rounded-lg">
                            <div className="flex flex-col justify-center items-center">
                              <div className="text-gray-600 pt-2 text-lg truncate text-center">
                                {vehicle?.registration}
                              </div>
                              <div className="w-auto pb-2">
                                <QRToyota
                                  value={`${vehicle?.registration}`}
                                  title={"Toyota"}
                                  size={120}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center mt-4 mb-8">
          <Pagination
            current={current}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onChange}
            total={vehicles?.length || 0}
            defaultPageSize={pageSize}
          />
        </div>
      </>
    </Manage>
  );
}
